import React from 'react'
import Translation from './Translation'

export const typeMap = {
    MK: <Translation id="mktool" defaultMessage="Marketing Tools" />,
    SH: <Translation id="showroom" defaultMessage="Showroom" />,
    WH: <Translation id="warehouse" defaultMessage="Warehouse" />,
    OPERATIONS: <Translation id="OPERATIONS" defaultMessage="Operations" />,
    SERVICE: <Translation id="SERVICE" defaultMessage="Services" />,
    '01': <Translation id="SAMPLES" defaultMessage="Samples" />,
    '02': <Translation id="OTHERS" defaultMessage="Others" />,
    '03': <Translation id="MERCHANDISING" defaultMessage="Merchandising" />,
    '04': <Translation id="LITERATURE" defaultMessage="Literature" />,
    '05': <Translation id="TAGS" defaultMessage="Tags" />,
    '06': <Translation id="ANCHORING" defaultMessage="anchoring" />,
    '07': <Translation id="BOXES" defaultMessage="Boxes" />,
    '08': <Translation id="DISPLAYS" defaultMessage="Displays" />,
    '09': <Translation id="BOOKS" defaultMessage="Books" />,
    '10': <Translation id="CABINETS" defaultMessage="Cabinets" />,
    '11': <Translation id="SIGNAGE" defaultMessage="Signage" />,
    '12': <Translation id="TEST_KITS" defaultMessage="Test kits" />,
    '13': <Translation id="WORKWEAR" defaultMessage="Workwear" />,
    '14': <Translation id="EPP" defaultMessage="EPP" />,
    '15': <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />,
    // New types
    'BASIN': <Translation id="BASIN" defaultMessage="Bathroom basin" />,
    'VANITY': <Translation id="VANITY" defaultMessage="Washbasin" />,
    'TILE': <Translation id="TILE" defaultMessage="Tile" />,
    'SLAB': <Translation id="SLAB" defaultMessage="Slab" />,
    'SINK': <Translation id="SINK" defaultMessage="Kitchen sink" />,
    'STRAY': <Translation id="STRAY" defaultMessage="Shower tray" />,
    'CLAD': <Translation id="CLAD" defaultMessage="Cladding" />,
    'FLOOR': <Translation id="FLOOR" defaultMessage="Flooring" />,
    'CLAD_FLOOR': <Translation id="CLAD_FLOOR" defaultMessage="Flooring and cladding" />,
    'ELAB': <Translation id="ELAB" defaultMessage="Elaborated" />,
    'PAN': <Translation id="PAN" defaultMessage="Panel" />,
    'PANEL RANURADO': <Translation id="PANEL_RANURADO" defaultMessage="Slatwall panel" />,
    'ACC': <Translation id="ACC" defaultMessage="Accessory" />,
    'C_M': <Translation id="C_M" defaultMessage="Cleaning and maintenance" />,
    'TOOL': <Translation id="TOOL" defaultMessage="Tool" />,
    'AD': <Translation id="AD" defaultMessage="Adhesive" />,
    'SIL': <Translation id="SIL" defaultMessage="Silicone" />,
    'T&R': <Translation id="T&R" defaultMessage="Treatment and repair" />,
}